import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, take, switchMap, of, catchError } from 'rxjs';
import { UserServiceNg } from './user.service';
import { isAdmin } from './roles';

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const users = inject(UserServiceNg);

  return users.user$.pipe(
    take(1),
    switchMap((user) => {
      if (user) return of(user);
      return users.fetchCurrentUser().pipe(catchError(() => of(null)));
    }),
    map((user) => {
      if (isAdmin(user?.roles)) return true;
      return router.parseUrl('/dashboard') as UrlTree;
    })
  );
};
